@if (searchFormControl$ | async; as formGroup) {
    <form [formGroup]="formGroup" (ngSubmit)="submit(formGroup)">
        <div class="container-fluid mb-3 mx-auto" style="max-width: 950px">
            <h1 class="mt-3">
                {{ 'titles_consumptionReport' | translate: 'online' : 'systems' }}
            </h1>
            <p>{{ 'consumptionReport_CRITERIA_PAGE_DESCRIPTION' | translate }}</p>
            <div class="card border-0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-xs-12">
                            <app-input-date-group
                                [label]="'reporting_START_DATE' | translate"
                                [required]="true"
                                formControlName="startDate" />
                        </div>
                        <div class="col-md-6 col-xs-12 ps-0">
                            <div class="ms-3">
                                <app-input-date-group
                                    [label]="'reporting_END_DATE' | translate"
                                    [required]="true"
                                    formControlName="endDate" />
                                <app-control-messages [control]="formGroup"></app-control-messages>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-xs-12 mb-3" formArrayName="deviceTypes">
                        <b class="required ms-3">{{
                            'common_DEVICE_USAGE' | translate: 'online' : 'common'
                        }}</b>
                        @for (deviceType of formGroup.controls.deviceTypes.controls; track $index) {
                            @if (deviceType.getRawValue(); as type) {
                                <div [formGroupName]="$index" class="ms-3">
                                    <app-checkbox-group
                                        [label]="
                                            ('mappers_allocationUnitMap.' + type.allocationUnit
                                                | translate: 'online' : 'common') +
                                            ' - ' +
                                            ('mappers_meterType.' + type.meterType
                                                | translate: 'online' : 'common') +
                                            ' - ' +
                                            ('mappers_measurementUnit.' + type.unit
                                                | translate: 'online' : 'common')
                                        "
                                        formControlName="selected"></app-checkbox-group>
                                </div>
                            }
                        }
                        <app-control-messages
                            [control]="formGroup.controls.deviceTypes"></app-control-messages>
                    </div>

                    <div class="col-md-6 col-xs-12 mb-3">
                        <div class="mb-3">
                            <b class="required ms-3">{{
                                'properties_INTERVAL' | translate: 'online' : 'common'
                            }}</b>
                            @for (periodInterval of periodIntervals; track $index) {
                                <div class="form-check ms-3">
                                    <input
                                        type="radio"
                                        class="form-check-input"
                                        id="{{ 'periodInterval' + $index }}"
                                        name="periodInterval"
                                        value="{{ periodInterval.periodInterval }}"
                                        formControlName="periodInterval" />
                                    <label
                                        class="form-check-label"
                                        for="{{ 'periodInterval' + $index }}"
                                        >{{
                                            'label_' + periodInterval.label
                                                | translate: 'online' : 'systems'
                                        }}</label
                                    >
                                </div>
                            }
                            <app-control-messages
                                [control]="
                                    formGroup.controls.periodInterval
                                "></app-control-messages>
                        </div>

                        <b class="required ms-3">{{
                            'mappers_allocationUnitMap.AG' | translate: 'online' : 'common'
                        }}</b>

                        @for (groupLevel of groupLevels; track $index) {
                            <div class="form-check ms-3">
                                <input
                                    type="radio"
                                    class="form-check-input"
                                    id="{{ 'groupLevel' + $index }}"
                                    name="groupLevel"
                                    value="{{ groupLevel.groupLevel }}"
                                    formControlName="groupLevel" />
                                <label class="form-check-label" for="{{ 'groupLevel' + $index }}">{{
                                    'titles_' + groupLevel.label | translate: 'online' : 'systems'
                                }}</label>
                            </div>
                        }
                        <app-control-messages
                            [control]="formGroup.controls.groupLevel"></app-control-messages>
                    </div>
                </div>
                <div class="text-end">
                    <button
                        type="button"
                        class="btn btn-primary me-3"
                        (click)="clearForm(formGroup)">
                        {{ 'actions_reset' | translate: 'online' : 'systems' }}
                    </button>
                    <button type="submit" class="btn btn-primary">
                        {{ 'actions_downloadReport' | translate: 'online' : 'systems' }}
                    </button>
                </div>
            </div>
        </div>
    </form>
}
